<template>
  <table class="table">
    <tbody>
      <tr>
        <td class="table-col">Серия</td>
        <td>{{ documentData.series }}</td>
      </tr>
      <tr>
        <td>Номер</td>
        <td>{{ documentData.number }}</td>
      </tr>
      <tr v-if="documentData.date_start">
        <td>Дата начала</td>
        <td>{{ documentData.date_start | formatDate }}</td>
      </tr>
      <tr v-if="documentData.date_end">
        <td>Дата окончания</td>
        <td>{{ documentData.date_end | formatDate }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DocumentOsagoView',
  props: ['documentData']
}
</script>

<style scoped>
  .table-col {
    width: 50%;
  }
</style>
